const ADJS = [
  'amber', 'azure', 'bold', 'bright', 'calm', 'clean', 'cool', 'dark',
  'fast', 'firm', 'flat', 'fresh', 'gold', 'hard', 'iron', 'keen',
  'lean', 'live', 'loud', 'mint', 'neat', 'null', 'prime', 'pure',
  'quick', 'rapid', 'sharp', 'slim', 'smooth', 'solid', 'steel', 'swift',
  'tidy', 'true', 'warm', 'wise',
]

const NOUNS = [
  'agent', 'arc', 'bot', 'build', 'byte', 'chain', 'ci', 'cli',
  'deploy', 'drone', 'flux', 'forge', 'gate', 'hawk', 'helm', 'hook',
  'job', 'key', 'lane', 'link', 'node', 'pack', 'pipe', 'plan',
  'pod', 'probe', 'pump', 'push', 'relay', 'run', 'scan', 'ship',
  'shot', 'sync', 'task', 'wave',
]

export function randomTokenName(): string {
  const adj  = ADJS[Math.floor(Math.random() * ADJS.length)]
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)]
  const num  = Math.floor(Math.random() * 9000) + 1000
  return `${adj}-${noun}-${num}`
}
